import { getConfig } from "@shared/library";

export const config = getConfig("Optisewer", window.location, process.env);